import * as types from './types';

const mutations = {
  // RESET
  [types.RESET](state) {
    state.jobs.draft = [];
    state.jobs.unpublishable = [];
    state.jobs.active = [];
    state.jobs.trashed = [];
    state.job = {};
  },

  // FETCH_JOBS
  [types.FETCH_JOBS_PENDING](state) {
    state.fetchJobsPending = true;
  },
  [types.FETCH_JOBS_FULFILLED](state, { jobs, listType }) {
    state.jobs[listType] = jobs;
    state.fetchJobsPending = false;
  },
  [types.FETCH_JOBS_ERROR](state) {
    state.fetchJobsPending = false;
  },

  // FETCH_JOB
  [types.FETCH_JOB_PENDING](state) {
    state.fetchJobPending = true;
  },
  [types.FETCH_JOB_FULFILLED](state, data) {
    state.job = data;
    state.fetchJobPending = false;
  },
  [types.FETCH_JOB_ERROR](state) {
    state.fetchJobPending = false;
  },

  // STORE_JOB
  [types.STORE_JOB_PENDING](state) {
    state.storeJobPending = true;
  },
  [types.STORE_JOB_FULFILLED](state) {
    state.storeJobPending = false;
  },
  [types.STORE_JOB_ERROR](state) {
    state.storeJobPending = false;
  },

  // DELETE_JOB
  [types.DELETE_JOB_PENDING](state) {
    state.deleteJobPending = true;
  },
  [types.DELETE_JOB_FULFILLED](state) {
    state.deleteJobPending = false;
  },
  [types.DELETE_JOB_ERROR](state) {
    state.deleteJobPending = false;
  },
};

export default mutations;
